import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const prefersDark =
  typeof window !== 'undefined' &&
  window.matchMedia?.('(prefers-color-scheme: dark)').matches;

export const useSettingsStore = create(
  persist(
    (set, get) => ({
      units: 'metric',
      discipline: 'ski',
      darkMode: prefersDark,
      nightMode: prefersDark,
      // Opt-in: broadcasting your live position to friends is off until the
      // user explicitly enables it (Settings or the map's share toggle).
      locationSharing: false,
      profileVisibility: 'friends',
      displayName: 'Skier',
      email: '',
      avatarUrl: null,
      tier: 'free',

      setUnits: (units) => set({ units }),
      setDiscipline: (discipline) => set({ discipline }),
      setDarkMode: (darkMode) => set({ darkMode, nightMode: darkMode }),
      setNightMode: (nightMode) => set({ nightMode, darkMode: nightMode }),
      toggleNightMode: () => {
        const current = get().nightMode;
        set({ nightMode: !current, darkMode: !current });
      },
      setLocationSharing: (locationSharing) => set({ locationSharing }),
      setProfileVisibility: (profileVisibility) => set({ profileVisibility }),
      setDisplayName: (displayName) => set({ displayName }),
      setEmail: (email) => set({ email }),
      setAvatarUrl: (avatarUrl) => set({ avatarUrl }),
      setTier: (tier) => set({ tier }),
    }),
    {
      name: 'powderlog-settings',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        units: state.units,
        discipline: state.discipline,
        nightMode: state.nightMode,
        darkMode: state.darkMode,
        locationSharing: state.locationSharing,
        profileVisibility: state.profileVisibility,
      }),
    },
  ),
);
